import Icon from "@ant-design/icons";

import type { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;
const ProductSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 2048 2048"
  >
    <path d="M0 0h2048v2048H0z" fill="none" />
    <path
      fill="currentColor"
      d="m960 120l832 416v1040l-832 415l-832-415V536zm625 456L960 264L719 384l621 314zM960 888l238-118l-622-314l-241 120zM256 680v816l640 320v-816zm768 1136l640-320V680l-640 320z"
    />
  </svg>
);
const ProductIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ProductSvg} {...props} />
);
export default ProductIcon;
